import {
  CONFIGURE_PENDING,
  CONFIGURE_SUCCESS,
  CONFIGURE_ERROR,
} from './constants';

export interface IAction<T = object> {
  type: string;
  payload?: T;
}

export const configure = (): IAction => ({
  type: CONFIGURE_PENDING,
});
export const configureSuccess = (config: Object): IAction => ({
  type: CONFIGURE_SUCCESS,
  payload: config,
});
export const configureError = (error: Error): IAction => ({
  type: CONFIGURE_ERROR,
  payload: error,
});
